import shortid from "shortid";

// 25/75
export default [
  {
    tagName: "mj-column",
    attributes: {
      width: "25%",
      "vertical-align": "top",
    },
    children: [],
    uid: shortid.generate(),
  },
  {
    tagName: "mj-column",
    attributes: {
      width: "75%",
      "vertical-align": "top",
    },
    children: [],
    uid: shortid.generate(),
  },
];
